import { Button, Form, Input } from "antd";
import { useState } from "react";
import { FormProvider } from "../../../common/provider/form/Form.provider";
import { SimpleInput } from "../../../common/components/simpleInput";
import { CustomButton } from "../../../common/components/CustomButton/CustomButton";
import { DynamicUploadFile } from "../../../common/components/Upload/DynamicUploadFile";
import { InputSelect } from "../../../common/components/InputSelect/InputSelect";
import { API_URLs } from "../../../utilities/API_URLs";
import { TransportOrderService } from "../core/_request";
import { HttpStatusCode } from "axios";
import { useTransportOrderForm } from "../store/_context";
import { CgPlayTrackNext } from "react-icons/cg";

export const CreationOT = () => {
  const [form] = Form.useForm();
  const { initialValue, handleNext, setOtData, onRefetch, otData } =
    useTransportOrderForm();
  const isHavingInitialData = initialValue || otData;

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  const onSubmitHandler = async (values: any) => {
    const { ...data } = values;

    try {
      const dataToPost = {
        ...data,
        ...(data?.customer
          ? {
              customer: data?.customer?.value,
            }
          : {}),

        ...(data?.storageLoad
          ? {
              storageLoad: data?.storageLoad?.value,
            }
          : {}),
        ...(data?.invoiceFile
          ? {
              invoiceFile: data?.invoiceFile?.value,
            }
          : {}),
        ...(data?.deliveryNoteFile
          ? {
              deliveryNoteFile: data?.deliveryNoteFile?.value,
            }
          : {}),
      };
      setIsLoadingSubmit(true);

      const res = await TransportOrderService.createTransport(dataToPost);

      if (res?.status === HttpStatusCode.Created) {
        setOtData(res?.data);
        handleNext();
        onRefetch && onRefetch();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const formatInitialData = (data: any) => {
    return {
      id: data?.id,
      ...(data?.customer
        ? {
            customer: {
              label: data?.customer?.name,
              value: data?.customer?.id,
            },
          }
        : {}),
      ...(data?.storageLoad
        ? {
            storageLoad: {
              label: data?.storageLoad?.uniqueIdentifierLoad,
              value: data?.storageLoad?.id,
            },
          }
        : {}),
      ...(data?.invoiceFile
        ? {
            invoiceFile: {
              label: data?.invoiceFile?.basename,
              value: data?.invoiceFile?.["@id"],
              key: data?.invoiceFile?.contentUrl,
            },
          }
        : {}),
      ...(data?.deliveryNoteFile
        ? {
            deliveryNoteFile: {
              label: data?.deliveryNoteFile?.basename,
              value: data?.deliveryNoteFile?.["@id"],
              key: data?.deliveryNoteFile?.contentUrl,
            },
          }
        : {}),
    };
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        initialValues={
          isHavingInitialData ? formatInitialData(initialValue || otData) : {}
        }
        debug={true}
        onFinish={onSubmitHandler}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>

        <div className="d-flex gap-4 mt-2">
          <div className="w-100">
            <SimpleInput
              Form={Form}
              label="Client"
              name={"customer"}
              rules={[
                {
                  required: true,
                  message: `Ce champ est requis`,
                },
              ]}
              customInput={
                <InputSelect
                  disabled={isHavingInitialData}
                  uri={`${API_URLs.settings.customers.getCustomerSelect}`}
                  params={{
                    customerCategory: "OTHER",
                  }}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              }
            />
          </div>
          <div className="w-100">
            <SimpleInput
              Form={Form}
              label="Conteneur"
              name={"storageLoad"}
              rules={[
                {
                  required: true,
                  message: `Ce champ est requis`,
                },
              ]}
              customInput={
                <InputSelect
                  uri={`${API_URLs.transports.selectStorage}`}
                  disabled={isHavingInitialData}
                  params={{
                    storageLoadState: "IN",
                    "operationLoad.loadType": "CONTAINER",
                  }}
                  valueOption={{
                    labelKey: "uniqueIdentifierLoad",
                    valueKey: "@id",
                  }}
                  //   disabled={!selectedTerrePlein}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              }
            />
          </div>
        </div>

        <div className="d-flex gap-4 mt-2">
          <div className="w-100">
            <SimpleInput
              Form={Form}
              label="Facture (PJ)"
              name={"invoiceFile"}
              rules={[
                {
                  required: true,
                  message: `Ce champ est requis`,
                },
              ]}
              customInput={<DynamicUploadFile form={form} name="invoiceFile" />}
            />
          </div>
          <div className="w-100">
            <SimpleInput
              Form={Form}
              label="Bon de livraison (PJ)"
              name={"deliveryNoteFile"}
              rules={[
                {
                  required: true,
                  message: `Ce champ est requis`,
                },
              ]}
              customInput={
                <DynamicUploadFile form={form} name="deliveryNoteFile" />
              }
            />
          </div>
        </div>

        <div className={"d-flex mt-4 justify-content-between gap-2"}>
          {isHavingInitialData ? (
            <Button size="small" variant="outlined" onClick={handleNext}>
              {" "}
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                Suivant
              </span>
              <CgPlayTrackNext
                style={{
                  height: "15px",
                  width: "15px",
                }}
              />
            </Button>
          ) : (
            <div className=""></div>
          )}
          <CustomButton
            type="submit"
            className={""}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
